// src/components/AnalyticsTracker.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase'; // Your initialized analytics instance

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // This logs a "page_view" event with the current path
    logEvent(analytics, 'page_view', {
      page_location: location.pathname + location.search,
      page_path: location.pathname + location.search,
    });
  }, [location]); // The effect runs every time the location changes

  return null; // This component doesn't render anything
}

export default AnalyticsTracker;